import { h, Component } from 'preact';
import { Router } from 'preact-router';
import Head from 'preact-helmet';
import Header from './header';
import Home from '../routes/home';
import Step from '../routes/step';
import Weldshop from '../routes/weldshop';
import Servicepack from '../routes/servicepack';
import Summary from '../routes/summary';
import System from '../routes/system';
import AutoPreload from '../components/autopreload';

// import Profile from '../routes/profile';
// import Home from 'async!./home';
// import Profile from 'async!./profile';

// const ua = window.navigator.userAgent;
// const IS_MOBILE = /Mobi/i.test(ua) || /Android/i.test(ua);

const REGEX_LOCALHOST = /^localhost|127\.0\.0\.1|192\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;

function scaleToWindow (rotateI) {
	const canonicalWidth = 1920;
	const canonicalHeight = 1080;
	const { innerWidth, innerHeight, document, screen } = window;
	const { availWidth, availHeight, orientation } = screen;
	const isLandscape = !!orientation && orientation.type.indexOf('landscape') === 0;

	const width = innerWidth ? Math.min(availWidth, screen.width, innerWidth) : (availWidth || screen.width);
	const height = innerHeight ? Math.min(availHeight, screen.height, innerHeight) : (availHeight || screen.height); // availHeight || screen.height || innerHeight;

	const widthRatio = width / canonicalWidth;
	// const heightRatio = height / canonicalHeight;

	const scale = widthRatio; //Math.max(widthRatio, heightRatio);
	const scaleValue = scale === 1 ? '' : `scale(${scale.toFixed(5)})`;

	if (document.documentElement.style.transform !== scaleValue) {
		document.documentElement.style.transform = scaleValue;
	}
}

function isKioskMode () {
	if (typeof window === 'undefined') {
		return false;
	}

	try {
		if ('kiosk' in localStorage) {
			if (localStorage.kiosk === '0') {
				return false;
			}

			else if (localStorage.kiosk === '1') {
				return true;
			}
		}
	}

	catch (err) {}

	return REGEX_LOCALHOST.test(window.location.hostname);
}

let KIOSK_MODE = isKioskMode();

if (typeof window !== 'undefined') {
	window.addEventListener('contextmenu', function (event) {
		if (KIOSK_MODE && (window.location.pathname !== '/system' || event.target.nodeName !== 'TEXTAREA')) {
			event.preventDefault();
		}
	});

	if (screen.orientation && screen.orientation.type && screen.orientation.type !== 'landscape' && typeof screen.orientation.lock === 'function') {
		screen.orientation.lock('landscape')
		.catch(err => undefined);
	}

	scaleToWindow();

	window.addEventListener('load', scaleToWindow);

	window.addEventListener('resize', scaleToWindow);
}

export default class App extends Component {
	constructor (props) {
		super(props);

		this.state = {
			section: 'home',
			subsection: '',
			kiosk: KIOSK_MODE
		};

		this.handleRoute = this.handleRoute.bind(this);
		this.changeSystem = this.changeSystem.bind(this);
	}

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute (event){
		const [section, subsection] = event.url.split('/').filter(s => !!s);

		this.setState({
			section: section || 'home',
			subsection: subsection || ''
		});
	}

	changeSystem ({ kiosk } = {}) {
		if (typeof kiosk === 'boolean' && kiosk !== this.state.kiosk) {
			KIOSK_MODE = kiosk;
			this.setState({ kiosk });

			try {
				localStorage.kiosk = kiosk ? '1' : '0';
			}

			catch (err) {}
		}
	}

	render({}, { kiosk, section, subsection }) {
		return (
			<div id="app" data-section={ section } data-kiosk={ kiosk }>
				<Head
					defaultTitle="Gastrak"
					title={ `Gastrak - ${section}${subsection && ` (${subsection})`}${ kiosk ? ' [kiosk]' : ''}` }
					meta={[
              {name: 'viewport', content: 'width=device-width, initial-scale=1'}
          ]}
				/>
				<Header kiosk={this.state.kiosk} section={this.state.section} />
				<Router onChange={ this.handleRoute }>
					<Home path="/" />
					<Step path="/q/:step" />
					<Weldshop path="/weldshop/:delivery/:identity/:extra?" />
					<Servicepack path="/servicepack/:servicepackIds" />
					<Summary kiosk={this.state.kiosk} path="/summary" />
					<System path="/system" kiosk={this.state.kiosk} onChange={this.changeSystem} />
				</Router>
				<AutoPreload instances={ 6 } />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js